export function sanitizeUrl(url: string): string {
  return url
    .replace(/\/\//, '/')
    .replace(/\/$/, '')
    .replace(/\/index$/, '');
}

export type RouteToScreenMap = {
  [K: string]: string | RouteToScreenMap | (() => any);
} & { index: string; useParams?: () => any };

export function flattenRoutes<T extends RouteToScreenMap>(routesMap: T, baseUrl = ''): T {
  return Object.keys(routesMap).reduce(
    (mem, route) => {
      if (route === 'index' || route === 'useParams') {
        return mem;
      }
      const value = routesMap[route];

      if (typeof value === 'string') {
        return { ...mem, [route]: sanitizeUrl(`${mem.index}/${value}`) };
      }
      return { ...mem, [route]: flattenRoutes(value as RouteToScreenMap, mem.index) };
    },
    { index: sanitizeUrl(`${baseUrl}/${routesMap.index}`), useParams: routesMap.useParams } as T,
  );
}
